export function initBackgroundImages() {
  const elements = document.querySelectorAll('[data-bg-image]');

  elements.forEach((element) => {
    const bgImage = element.getAttribute('data-bg-image');
    if (bgImage) {
      element.style.backgroundImage = `url(${bgImage})`;
    }
  });
}

document.addEventListener('DOMContentLoaded', initBackgroundImages);
